import { render, staticRenderFns } from "./CommentCertDialog.vue?vue&type=template&id=c58909ee&scoped=true&"
import script from "./CommentCertDialog.vue?vue&type=script&lang=js&"
export * from "./CommentCertDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommentCertDialog.vue?vue&type=style&index=0&id=c58909ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58909ee",
  null
  
)

export default component.exports